import React, { useMemo } from "react";
import { Pie } from "react-chartjs-2";

const OrderPaymentFailureReasonDistribution = ({ data }) => {
	const total = useMemo(() => {
		let v = 0;
		for (let key in data) v += data[key];
		return v;
	}, [data]);
	const distributionData = useMemo(() => {
		let modData = {};
		let submitExceptions = 0;
		let checkoutServiceImplDirectDebitPayments = 0;
		for (let key in data) {
			if (key.startsWith("Exception while Submitting payment Request to Gateway for Order ID: ")) {
				submitExceptions += data[key];
			} else if (key.startsWith("ApiException in CheckoutServiceImpl.directDebitPayments while making Direct Debit Payment, Order ID: ")) {
				checkoutServiceImplDirectDebitPayments += data[key];
			} else {
				modData[key] = data[key];
			}
		}
		if (submitExceptions > 0) modData["Payment Submittion Request Exception"] = submitExceptions;
		if (submitExceptions > 0) modData["ApiException in CheckoutServiceImpl.directDebitPayments while making Direct Debit Payment"] = checkoutServiceImplDirectDebitPayments;
		let labels = Object.keys(modData)
			.reduce((p, c) => {
				p.push(c);
				return p;
			}, [])
			.sort();
		return {
			labels: labels,
			datasets: [
				{
					data: labels.map((l) => modData[l.trim()]),
					backgroundColor: labels.map((l) => "#" + Math.floor(Math.random() * 16777215).toString(16)),
					hoverOffset: 4,
				},
			],
		};
	}, [data]);

	return (
		<Pie
			data={distributionData}
			options={{
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: true,
						position: "left",
						maxWidth: 600,
					},
					tooltip: {
						callbacks: {
							label: function (context) {
								let value = context.dataset.data[context.dataIndex];
								const percentage = ((value / total) * 100).toFixed(0);
								return `${context.label.trim()}: ${value} (${percentage}%)`;
							},
						},
					},
				},
			}}
		/>
	);
};

export default OrderPaymentFailureReasonDistribution;
